import { render, staticRenderFns } from "./IconSvgPartners.vue?vue&type=template&id=a5ac668e&scoped=true&"
import script from "./IconSvgPartners.vue?vue&type=script&lang=js&"
export * from "./IconSvgPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ac668e",
  null
  
)

export default component.exports